import {Injectable} from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {AuthenticationService} from '../../services/authentication.service';
import {User} from '../../models';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {

    public _currentUser: User;

    constructor(private _authService: AuthenticationService) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

        if (typeof window !== 'undefined') {
            if(request.url.includes(`${environment.crmBaseUrl}/${environment.appUser}`)) {
                return next.handle(request);
            }
            if(request.url.includes(`${environment.crmBaseUrl}/${environment.user}`)) {
                request = request.clone({
                    setHeaders: {
                        'Content-Type': 'application/json',
                        'Authorization': `Basic ${btoa('userreg:scSfjpB52rUawu12izbp')}`
                    }
                });
                return next.handle(request);
            }

            let currentUser = this._authService.getCurrentUser;
            if (currentUser) {
                if (currentUser.id == '6239744d8b2d7d361') {
                    request = request.clone({
                        setHeaders: {
                            'Content-Type': 'application/json',
                            'x-api-key': 'c5a8d58698329bde3ae6cd0c972815c9'
                        }
                    });
                    return next.handle(request);
                } else {
                    request = request.clone({
                        setHeaders: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Basic ' + currentUser.authdata
                        }
                    });
                    return next.handle(request);
                }
            } else {
                request = request.clone({
                    setHeaders: {
                        'Content-Type': 'application/json',
                        'x-api-key': 'c5a8d58698329bde3ae6cd0c972815c9'
                    }
                });
                return next.handle(request);
            }
        } else {
            console.warn('BasicAuthInterceptor yalnızca tarayıcı ortamında çalışacak şekilde yapılandırılmıştır.');
        }

        return next.handle(request);
    }
}
